import { LANGUAGES } from '@/utils/constants'

const { PORTUGUESE, ENGLISH, SPANISH } = LANGUAGES

export const NEXT = 'next'
export const PLACEHOLDER_COUNTRY = 'placeholder country'

export default {
  [PORTUGUESE]: {
    [NEXT]: 'Próximo',
    [PLACEHOLDER_COUNTRY]: 'Adicionar cota ao país',
  },

  [ENGLISH]: {
    [NEXT]: 'Next',
    [PLACEHOLDER_COUNTRY]: 'Add quota to country',
  },

  [SPANISH]: {
    [NEXT]: 'Próximo',
    [PLACEHOLDER_COUNTRY]: 'Agregar cuota al país',
  },
}
